import store from './index';
export const selectCountriesDictionary = () => store((state) => state.dictionary);
export const selectAvailableContinents = () => store((state) => state.availableContinents);
export const selectContinentsOverview = () => store((state) => state.continentsOverview);
export default {
    getCountriesDictionary: store.getState().getCountriesDictionary,
    getAvailableContinents: store.getState().getAvailableContinents,
    getContinentsOverview: store.getState().getContinentsOverview,
};
